import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/new/images/svg/avatar-default.svg")